<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import { documentIcons, DocumentType } from "module/foundryDocuments";

  let { folderNode }: { folderNode: FolderTree } = $props();
  let hasChildren = $derived(Boolean(folderNode.children?.length));
  let expanded = $state(false);

  const dispatch = createEventDispatcher();
</script>

<li
  class:selected={folderNode.selected}
  on:click={() => dispatch("selectFolder", folderNode.folder.id)}
>
  <span>
    <i class="fas {documentIcons[folderNode.folder.type as DocumentType]}"></i>
    {folderNode.folder.name}
  </span>
  {#if hasChildren}
    <i
      class="fas fa-caret-{expanded ? 'up' : 'down'} folder-toggle"
      on:click|stopPropagation={() => (expanded = !expanded)}
    ></i>
  {/if}
</li>

{#if expanded}
  <ul>
    {#each folderNode.children as node (node.folder.id)}
      <svelte:self folderNode={node} on:selectFolder />
    {/each}
  </ul>
{/if}

<style>
  li {
    display: flex;
    align-items: center;
    line-height: 1.8em;
    flex-wrap: wrap;
    gap: 0.3em;
    padding: 0 0.6em;
    background: rgba(255, 255, 255, 0.15);
    cursor: pointer;
    justify-content: space-between;
    margin-left: 10px !important;
    margin-bottom: 0 !important;
  }

  li:hover {
    background: rgba(255, 255, 255, 0.35);
  }

  .selected {
    background: rgba(0, 0, 0, 0.5);
    color: var(--color-light-2);
  }

  .selected:hover {
    background: rgba(0, 0, 0, 0.4);
  }

  ul {
    margin: 0 !important;
    width: 100%;
    list-style: none;
    width: auto;
    margin-bottom: 3px !important;
  }
  .folder-toggle {
    width: 15px;
    margin-left: 3px;
    display: inline-flex;
    justify-content: center;
    border-radius: 4px;
    padding: 3px;
    transition: background-color 150ms cubic-bezier(0.4, 0, 0.04, 1);
  }
  .folder-toggle:hover {
    background: #0003;
  }

  .folder-toggle:active {
    box-shadow: inset 0 0 0 1px #0003;
  }
</style>
